const root = (state) => state.auth;

const loggedInDevicesSelector = (state) => root(state).loggedInDevicesSummary;

export { loggedInDevicesSelector };
